<div *ngIf="loadingData" class="alert alert-info"><strong><i class="la la-spinner la-spin"></i> Nalagam podatke</strong>
</div>
<form [formGroup]="form" novalidate (submit)="update(form)" *ngIf="contractor">
  <div class="form-group">
    <label for="title">Naziv ustanove</label>
    <input type="text" class="form-control" id="title" formControlName="title">
  </div>

  <div class="form-row">
    <div class="form-group col-md-6">
      <label for="address">Naslov</label>
      <input type="text" class="form-control" id="address" formControlName="address">
    </div>
    <div class="form-group col-md-2">
      <label for="postNumber">Pošta</label>
      <input
        formControlName="postNumber"
        [typeahead]="postNumbersFilter"
        [typeaheadItemTemplate]="customItemTemplate"
        id="postNumber"
        (typeaheadOnSelect)="onPostSelect($event)"
        autocomplete="off"
        class="form-control">
    </div>

    <div class="form-group col-md-4">
      <label for="poste">Pošta</label>
      <input
        formControlName="poste"
        [typeahead]="posteFilter"
        [typeaheadItemTemplate]="customItemTemplate"
        id="poste"
        (typeaheadOnSelect)="onPostSelect($event)"
        autocomplete="off"
        class="form-control">
    </div>

    <ng-template #customItemTemplate let-model="item" let-index="index">
      {{model.number}} {{model.name}}
    </ng-template>
  </div>

  <div class="form-group mb-5">
    <label for="website">Spletna stran</label>
    <input type="text" class="form-control" id="website" formControlName="website">
    <small class="form-text text-danger" *ngIf="form.controls.website.touched && form.controls.website.invalid">
      Spletna stran ni v pravilni obliki (https://www.zdravstvena-ustanova.si/ambulanta-1/)
    </small>
  </div>

  <div class="form-row">
    <div class="form-group col-md-6">
      <label class="d-flex justify-content-between align-items-center">
        Telefonske številke
        <button class="button button-3d button-light button-mini m-0 px-2" type="button" (click)="addPhoneNumber()">
          <i class="la la-plus"></i> Dodaj
        </button>
      </label>
      <div formArrayName="phoneNumbers" *ngFor="let item of form.get('phoneNumbers').controls; let i = index;"
           class="mb-1">
        <div class="input-group mb-1" [formGroupName]="i">
          <input type="text" class="form-control" formControlName="phoneNumber">
          <div class="input-group-append">
            <button class="btn btn-outline-danger btn-xs" (click)="removePhoneNumber(i)" type="button"><i
              class="la la-remove"></i>
            </button>
          </div>
        </div>

      </div>
    </div>

    <div class="form-group col-md-6">
      <label class="d-flex justify-content-between align-items-center">
        E-naslovi
        <button class="button button-3d button-light button-mini m-0 px-2" type="button" (click)="addEmail()">
          <i class="la la-plus"></i> Dodaj
        </button>
      </label>
      <div formArrayName="emails" *ngFor="let item of form.get('emails').controls; let i = index;"
           class="mb-1">
        <div class="input-group mb-1" [formGroupName]="i">
          <input type="text" class="form-control" formControlName="email">
          <div class="input-group-append">
            <button class="btn btn-outline-danger btn-xs" type="button" (click)="removeEmail(i)"><i
              class="la la-remove"></i>
            </button>
          </div>
        </div>
        <small class="form-text text-danger" *ngIf="item.controls.email.touched && item.controls.email.invalid">
          Elektronski naslov ni pravilen.
        </small>
      </div>
    </div>
  </div>

  <ng-container *ngIf="contractor && contractor.acf.contractor_premium">
    <div class="form-group mt-3">
      <label for="premium">Premium vsebine</label>
      <select id="premium" type="text" class="form-control" formControlName="premium">
        <option [value]="false">Brez</option>
        <option [value]="premium.id" *ngFor="let premium of premiums">{{premium.title.raw}}</option>
      </select>
    </div>
    <div class="d-flex justify-content-end">
      <button class="button button-3d button-light button-small align-self-end" type="button"
              [routerLink]="['/ustanova', contractor.id, 'premium', 'nov']">
        <i class="la la-plus"></i> Kreiraj novo premium vsebino
      </button>
    </div>
  </ng-container>

  <hr>
  <div class="d-flex justify-content-between">
    <div>
      <div class="style-msg successmsg" *ngIf="formSucces">
        <div class="sb-msg">
          <i class="icon-thumbs-up"></i>
          <strong>Bravo!</strong>
          Podatki so bili uspešno shranjeni.
        </div>
      </div>
      <div class="style-msg errormsg" *ngIf="formError">
        <div class="sb-msg">
          <i class="icon-thumbs-up"></i>
          <strong>Napaka!</strong>
          {{formError}}
        </div>
      </div>
    </div>
    <button type="submit" class="button button-3d button-primary button-disabled" [disabled]="formProcessing">
      <i class="la la-check" *ngIf="!formProcessing"></i>
      <i class="la la-spinner la-spin" *ngIf="formProcessing"></i>
      Shrani spremembe
    </button>
  </div>
</form>
